export default {
  ineps: [],
  pagination: {},
  inep: {}
}
